<div class="relative">
  <button
    (click)="toggle()"
    class="w-full flex items-center gap-3 px-4 py-3 rounded-lg text-base-content hover:bg-base-200 transition-colors font-medium"
    [attr.aria-label]="
      unreadCount > 0 ? unreadCount + ' unread notifications' : 'Notifications'
    "
  >
    <span class="relative flex-shrink-0">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        class="h-5 w-5"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9"
        />
      </svg>
      @if (unreadCount > 0) {
        <span
          class="absolute -top-1.5 -right-1.5 badge badge-error badge-xs text-error-content font-semibold px-1"
        >
          {{ unreadCount > 9 ? '9+' : unreadCount }}
        </span>
      }
    </span>
    Notifications
  </button>

  @if (isOpen) {
    <!-- click-away layer; sits under the panel so the panel stays clickable -->
    <button
      class="fixed inset-0 z-40 cursor-default"
      aria-label="Close notifications"
      (click)="close()"
    ></button>

    <div
      class="absolute bottom-full left-0 mb-2 w-80 max-h-96 flex flex-col bg-base-100 border border-base-300 rounded-lg shadow-lg z-50"
    >
      <div class="flex items-center justify-between px-4 py-3 border-b border-base-300">
        <span class="font-semibold text-sm">Notifications</span>
        @if (unreadCount > 0) {
          <button class="btn btn-ghost btn-xs" (click)="markAllAsRead()">Mark all read</button>
        }
      </div>

      @if (notifications.length === 0) {
        <p class="px-4 py-8 text-center text-sm text-base-content/60">Nothing yet.</p>
      } @else {
        <ul class="overflow-y-auto divide-y divide-base-200">
          @for (notification of notifications; track notification.id) {
            <li>
              <div
                class="w-full flex items-start gap-2 px-4 py-3 hover:bg-base-200 transition-colors"
              >
                <button class="flex-1 text-left" (click)="open(notification)">
                  <span class="flex items-start gap-2">
                    @if (!notification.isRead) {
                      <span
                        class="mt-1.5 h-2 w-2 rounded-full bg-primary flex-shrink-0"
                        aria-hidden="true"
                      ></span>
                    }
                    <span class="flex-1">
                      <span
                        class="block text-sm leading-snug"
                        [class.font-semibold]="!notification.isRead"
                      >
                        {{ notification.message }}
                      </span>
                      <span class="block text-xs text-base-content/50 mt-0.5">
                        {{ notification.createdAt | date: 'short' }}
                      </span>
                    </span>
                  </span>
                </button>
                <button
                  class="btn btn-ghost btn-xs text-base-content/40 hover:text-error"
                  aria-label="Dismiss"
                  (click)="dismiss(notification, $event)"
                >
                  ✕
                </button>
              </div>
            </li>
          }
        </ul>
      }
    </div>
  }
</div>
